<template v-cloak>
  <div class="alert" role="alert" :class="alertClasses">
    <Icon :icon="icon" />
    <p v-if="url && message"><a :href="url" v-html="message" class="alert__link" /></p>
    <p v-else-if="message" v-html="message" />
    <Icon icon="arrow-right" v-if="!!url" />
  </div>
</template>

<script>
import { computed, defineComponent } from 'vue';
import Icon from './Icon.vue';

export default defineComponent( {
  name: 'Alert',
  components: {
    Icon,
  },
  props: {
    icon: {
      type: String,
      default: 'info'
    },
    type: {
      type: String,
      default: 'info'
    },
    message: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: '',
    }
  },
  setup( props ) {

    const alertClasses = computed( () => ( {
      [ `alert--${ props.type }` ]: !! props.type,
    } ) );

    return {
      alertClasses,
    };
  }
} );
</script>
